var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6555 0.12625C16.8262 0.236589 16.9447 0.408144 16.985 0.603181C17.0252 0.798217 16.9839 1.00076 16.8701 1.16626L7.58681 14.6664C7.52329 14.7587 7.43946 14.8361 7.34135 14.8932C7.24324 14.9502 7.13331 14.9855 7.01946 14.9964C6.90561 15.0073 6.79068 14.9936 6.68296 14.9562C6.57524 14.9189 6.4774 14.8588 6.39649 14.7804L0.207628 8.78035C0.0709777 8.63818 -0.0034156 8.45013 0.000120525 8.25582C0.00365665 8.06152 0.0848462 7.87613 0.226584 7.73872C0.368323 7.6013 0.559543 7.52259 0.75996 7.51916C0.960377 7.51573 1.15434 7.58786 1.30099 7.72034L6.82249 13.0734L15.5828 0.333252C15.6968 0.167927 15.8738 0.0532496 16.075 0.014432C16.2761 -0.0243856 16.485 0.0158345 16.6555 0.12625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9e0ce46f1593338e195e6d722210ec1f.svg";
export { ForwardRef as ReactComponent };